import POShipmentSearchType from './POShipmentSearchTypes';

export const getShipmentInfoListInProgress = (payload) => {
  return { payload, type: POShipmentSearchType.GET_SHIPMENT_INFO_LIST };
};

export const getShipmentInfoListInSuccess = (payload) => {
  return {
    payload,
    type: POShipmentSearchType.GET_SHIPMENT_INFO_LIST_SUCCESS,
  };
};

export const getShipmentInfoListListInFail = (payload) => {
  return {
    payload,
    type: POShipmentSearchType.GET_SHIPMENT_INFO_LIST_FAIL,
  };
};

export const getShipmentInfoListListInReset = () => {
  return {
    type: POShipmentSearchType.GET_SHIPMENT_INFO_LIST_RESET,
  };
};

export const updateShipmentInfoListRequest = (payload) => {
  return {
    payload,
    type: POShipmentSearchType.UPDATE_SHIPMENT_INFO_LIST_REQUEST,
  };
};

export const saveShipmenOtherDetailsInProgress = (payload) => {
  return {
    payload,
    type: POShipmentSearchType.SAVE_SHIPMENT_OTHER_DETAILS_PROGRESS,
  };
};

export const saveShipmenOtherDetailsInFail = (payload) => {
  return {
    payload,
    type: POShipmentSearchType.SAVE_SHIPMENT_OTHER_DETAILS_FAIL,
  };
};

export const updateShipmentInfoCheckedItems = (payload) => {
  return {
    payload,
    type: POShipmentSearchType.UPDATE_SHIPMENT_INFO_LIST_CHECKED_ITEMS,
  };
};

export const setShipmentSearchExportModal = (payload) => {
  return {
    payload,
    type: POShipmentSearchType.SET_SHIPMENT_SEARCH_EXPORT_TOGGLE,
  };
};
